import React, { useRef, useEffect, useState} from 'react';
import GiPhylogram from "../../chart/GiPhylogram"

function Screen2Phylogram(props:any) {

    let newickData:any        = props.newickData;
    let cloneLocationData:any = props.cloneLocationData;
    let phyloInfoData:any     = props.phyloInfoData;
    let initData:any          = props.initialization;

    initData.onDrawVafRect = function (bulkName:string, bulkId:string){
        
        initGiPhylogramData.draw_bulk_id = bulkId;
        setPhylogeneticBulkName("in " + bulkName);
            // console.log(bulkId)
            // initGiPhylogramData.onDrawVafRect(bulkId)
        
    }

    let[phylogeneticBulkName, setPhylogeneticBulkName] = useState<string>("");

    const card1:any = useRef();

    let [initGiPhylogramData, setInitGiPhylogramData]= useState<any>({ 
        detail_title_field:{source_filed:'lineage_id_cindel', target_field:'sample_id' },
        width: initData.width,
        height: 580,
        min_height: 580,
        max_height: 1000,
        legend_field: 'Cell_type',
        vaf_legend: true,
        draw_bulk_id: undefined,
        callback_after_click_reck: initData.callback_after_click_reck
      });

    useEffect(() => {
        // if(card1.current){
        //     initGiPhylogramData.width = card1.current.offsetWidth;
        //   }
    });


    return (
        <React.Fragment>
        
            <div className="card card-primary">
                <div className="card-header">
                  <h3 className="card-title">Variant-allele frequency {phylogeneticBulkName} on the phylogenetic tree</h3>
                </div>
                <div className="card-body">
                  <div ref={card1}>
                    <GiPhylogram newickData={newickData} detailData={cloneLocationData} vafData={phyloInfoData} initialization={initGiPhylogramData} />
                    <p className="card-text">
                        When you click early branches, you can see the list of early mutations in the below panel.
                    </p>
                  </div>
                  
                </div>
            </div>
        
        </React.Fragment>
    );
}

export default Screen2Phylogram;